import { render } from "./ContactsPersons.vue?vue&type=template&id=70fa73eb"
import script from "./ContactsPersons.vue?vue&type=script&lang=js"
export * from "./ContactsPersons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__